import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { hasDefaultComponent } from "../../../utils/pageModelUtils";
import { TFieldValidationResult } from "./CtaFieldValidations.types";

export const plasticCardDesignFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    const validationResult: TFieldValidationResult = {};

    if (
        hasDefaultComponent(
            'cob-corp-acquisition/components/creditonebank/plastic-card-design',
        ) && !validatingState.getSelectedCardId()
    ) {
        validationResult['SelectedCardId'] = 'RequiredField';
    }

    return validationResult;
};